import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { FormBuilder, ValidationErrors, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ImageService } from '../../../../../../services/images/image.service';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { PersonGenderService } from '../../../../../../services/person-genders/person-gender.service';
import { StudentService } from '../../../../../../services/students/student.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DivisionService } from '../../../../../../services/divisions/division.service';
import { RelationshipService } from '../../../../../../services/relationships/relationship.service';
import { AddStudentDto } from '../../../../../../models/students/dto/AddStudentDto';
import { TutorService } from '../../../../../../services/tutors/tutor.service';
import { Tutor } from '../../../../../../models/tutors/tutor';
import * as moment from 'moment';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';

import { Lightbox } from 'ngx-lightbox';
import { MY_FORMATS } from '../../../../../../const/date-format';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { DocumentationService } from '../../../../../../services/documentations/documentation.service';
import { Observable } from 'rxjs/Observable';
import { PaymentComponent } from '../payment/payment.component';
import { Payment } from '../../../../../../models/payment/payment';
import { PaymentConceptService } from '../../../../../../services/payment-concept/payment-concept.service';
import { PendingSubjectComponent } from '../pending-subjects/pending-subject.component';
import { CourseYearSubject } from '../../../../../../models/course-year-subject/course-year-subject';
import { Curriculum } from '../../../../../../models/curricula/curriculum';
import { CurriculumService } from '../../../../../../services/curricula/curriculum.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { Division } from '../../../../../../models/divisions/division';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-add-student',
    templateUrl: './add-student.component.html',
    styleUrls: ['./add-student.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class FuseAddorEditStudentComponent implements OnInit, AfterViewInit, OnDestroy {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    studentFormGroup;
    tutorFormGroup;

    courseFormControl;
    curriculumFormControl;
    shiftFormControl;
    studentDocNumberFormControl;
    studentCuilNumberFormControl;
    studentEmailNumberFormControl;
    studentLastNameFormControl;
    studentFirstNameFormControl;
    studentBirthdateFormControl;
    studentGenderFormControl;
    studentHasBrothersOfSchoolAgeFormControl;
    studentRepeatStudentFormControl;
    nationalityFormControl;
    OcupationFormControl;
    schoolOriginFormControl;

    tutorDocNumberFormControl;
    tutorLastNameFormControl;
    tutorFirstNameFormControl;
    tutorBirthdateFormControl;
    tutorGenderFormControl;
    tutorRelationshipFormControl;
    tutorCuilNumberFormControl;
    tutorEmailNumberFormControl;
    tutorHighestEducationLevelFormControl;

    markerLngX: number = null;
    markerLatY: number = null;
    confirmDialogRef: any;
    public baseUri;
    public colegio;

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerTutorBirthdate;
    maskedInputControllerStudentBirthdate;

    divisionsFiltered: Division[];

    @ViewChild('tutorBirthdate', {read: ViewContainerRef}) public tutorBirthdate;
    @ViewChild('studentBirthdate', {read: ViewContainerRef}) public studentBirthdate;
    private documentations: any[];

    formControlTitles: { [key: string]: string } = {};

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseAddorEditStudentComponent>,
        private translationService: TranslationService,
        private translate: TranslateService,
        private sweetAlertService: SweetAlertService,
        private studentService: StudentService,
        private fb: FormBuilder,
        private imageService: ImageService,
        public personGenderService: PersonGenderService,
        private divisionService: DivisionService,
        private relationshipService: RelationshipService,
        private tutorService: TutorService,
        private authenticationService: AuthenticationService,
        private _lightbox: Lightbox,
        public documentationService: DocumentationService,
        public dialog: MatDialog,
        public paymentConceptService: PaymentConceptService,
        public curriculumService: CurriculumService,
        public shiftService: ShiftService
    ) {
        console.log('FuseAddStudentComponent > data Add StudentComponentPopup', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
        this.colegio = environment.colegio;
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        const observables = [];
        if (this.data.student.Id != "-1") {
            observables.push(this.studentService.getById(this.data.student.Id, this.authenticationService.getAuthData().SchoolYear.Id));
        }
        observables.push(this.divisionService.getAllBySchoolYearId(this.authenticationService.getAuthData().SchoolYear.Id));
        observables.push(this.relationshipService.getAll());
        observables.push(this.personGenderService.getAll());
        observables.push(this.documentationService.getAll());
        observables.push(this.paymentConceptService.getAll());
        observables.push(this.curriculumService.getAll());
        observables.push(this.shiftService.getAll());
        let getTutor = false;
        // if (!this.data.student.Tutor) {
            this.data.student.Tutor = new Tutor();
            observables.push(this.tutorService.getById(this.data.student.Id));
            getTutor = true;
        // }

        Observable.combineLatest(
            observables
        ).subscribe((result) => {
            console.log('result', result);
            this.blockUI.stop();
            if (this.data.student.Id != "-1") {
                this.data.student = result[0];
            }
            if (getTutor) {
                this.data.student.Tutor = result[result.length - 1] != null?result[result.length - 1] : new Tutor();
            }

            console.log('this.documentationService.documentations', this.documentationService.documentations);

            this.documentations = [...this.documentationService.documentations];
            this.documentations.forEach(e => {
                e.Checked = this.data.student.Documentations.find(doc => doc === e.Id);
            });

            console.log(this.data.student);
            this.filterDivisions();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });

        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    getTutor(studentId: string) {
        this.tutorService.getById(studentId).subscribe(response => {
            this.blockUI.stop();
            const tutor = new Tutor();
            this.data.student.Tutor = response;

            console.log('asdsfdasfasdfadsfaf********************sdfsf', response.FirstName);
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    disable() {
        this.studentFormGroup.get('courseFormControl').disable();
        this.studentFormGroup.get('curriculumFormControl').disable();
        this.studentFormGroup.get('shiftFormControl').disable();
        this.studentFormGroup.get('studentDocNumberFormControl').disable();
        this.studentFormGroup.get('studentCuilNumberFormControl').disable();
        this.studentFormGroup.get('studentEmailNumberFormControl').disable();
        this.studentFormGroup.get('studentLastNameFormControl').disable();
        this.studentFormGroup.get('studentFirstNameFormControl').disable();
        this.studentFormGroup.get('studentBirthdateFormControl').disable();
        this.studentFormGroup.get('studentGenderFormControl').disable();
        this.studentFormGroup.get('studentHasBrothersOfSchoolAgeFormControl').disable();
        this.studentFormGroup.get('studentRepeatStudentFormControl').disable();

        this.studentFormGroup.get('tutorDocNumberFormControl').disable();
        this.studentFormGroup.get('tutorHighestEducationLevelFormControl').disable();
        this.studentFormGroup.get('tutorCuilNumberFormControl').disable();
        this.studentFormGroup.get('tutorEmailNumberFormControl').disable();
        this.studentFormGroup.get('tutorLastNameFormControl').disable();
        this.studentFormGroup.get('tutorFirstNameFormControl').disable();
        this.studentFormGroup.get('tutorBirthdateFormControl').disable();
        this.studentFormGroup.get('tutorGenderFormControl').disable();
        this.studentFormGroup.get('tutorRelationshipFormControl').disable();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.maskedInputControllerTutorBirthdate = textMask.maskInput({
                inputElement: this.tutorBirthdate.element.nativeElement,
                mask: this.mask
            });

            this.maskedInputControllerStudentBirthdate = textMask.maskInput({
                inputElement: this.studentBirthdate.element.nativeElement,
                mask: this.mask
            });
        });
    }

    ngOnDestroy() {
        this.maskedInputControllerTutorBirthdate.destroy();
        this.maskedInputControllerStudentBirthdate.destroy();
    }

    initializeFormControlValidators() {
        this.studentFormGroup = this.fb.group({
            courseFormControl: ['', [Validators.required]],
            curriculumFormControl: ['', [Validators.required]],
            shiftFormControl: ['', [Validators.required]],
            studentDocNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            studentCuilNumberFormControl: ['', [Validators.required]],
            studentEmailNumberFormControl: ['', [
                (control) => control.value ? Validators.email(control) : null
              ]],
            studentLastNameFormControl: ['', [Validators.required]],
            studentFirstNameFormControl: ['', [Validators.required]],
            studentBirthdateFormControl: ['', [Validators.required]],
            studentGenderFormControl: ['', [Validators.required]],
            studentHasBrothersOfSchoolAgeFormControl: [this.data.student.HasBrothersOfSchoolAge, [Validators.required]],
            studentRepeatStudentFormControl: [this.data.student.RepeatStudent, [Validators.required]],
            tutorDocNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            tutorCuilNumberFormControl: ['', [Validators.required]],
            tutorHighestEducationLevelFormControl: [''],
            tutorEmailNumberFormControl: ['', [
                (control) => control.value ? Validators.email(control) : null
              ]],
            tutorLastNameFormControl: ['', [Validators.required]],
            tutorFirstNameFormControl: ['', [Validators.required]],
            tutorBirthdateFormControl: ['', [Validators.required]],
            tutorGenderFormControl: ['', [Validators.required]],
            tutorRelationshipFormControl: ['', [Validators.required]],
        });
        
        // this.tutorFormGroup = this.fb.group({
        //     tutorDocNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
        //     tutorLastNameFormControl: ['', [Validators.required]],
        //     tutorFirstNameFormControl: ['', [Validators.required]],
        //     tutorBirthdateFormControl: ['', [Validators.required]],
        //     tutorGenderFormControl: ['', [Validators.required]],
        //     tutorRelationshipFormControl: ['', [Validators.required]],
        // });


        this.formControlTitles = {
            courseFormControl: 'LABELS.COURSE',
            curriculumFormControl: 'FIELDS.CURRICULUM',
            shiftFormControl: 'LABELS.SHIFTS',
            studentDocNumberFormControl: 'FIELDS.DOCUMENT_NUMBER_ALUMNO',
            studentCuilNumberFormControl: 'FIELDS.CUIL_ALUMNO',
            studentEmailNumberFormControl: 'FIELDS.EMAIL_ALUMNO',
            studentLastNameFormControl: 'FIELDS.LAST_NAME_ALUMNO',
            studentFirstNameFormControl: 'FIELDS.FIRST_NAME_ALUMNO',
            studentBirthdateFormControl: 'FIELDS.BIRTHDATE_ALUMNO',
            studentGenderFormControl: 'FIELDS.GENDER_ALUMNO',
            studentHasBrothersOfSchoolAgeFormControl: 'FIELDS.HAS_BROTHERS_SCHOOL_AGE',
            studentRepeatStudentFormControl: 'LABELS.PROMOTED_REPEATER_REENROLLED',

            tutorDocNumberFormControl: 'FIELDS.DOCUMENT_NUMBER_TUTOR',
            tutorCuilNumberFormControl: 'FIELDS.CUIL_TUTOR',
            tutorHighestEducationLevelFormControl: 'FIELDS.CURRICULUM',
            tutorEmailNumberFormControl: 'FIELDS.EMAIL_TUTOR',
            tutorLastNameFormControl: 'FIELDS.LAST_NAME_TUTOR',
            tutorFirstNameFormControl: 'FIELDS.FIRST_NAME_TUTOR',
            tutorBirthdateFormControl: 'FIELDS.BIRTHDATE_TUTOR',
            tutorGenderFormControl: 'FIELDS.GENDER_TUTOR',
            tutorRelationshipFormControl: 'FIELDS.RELATIONSHIP',
        };
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    filterDivisions() {
        console.log(this.divisionService.divisions);
        console.log(this.data.student.CurriculumId);
        console.log(this.data.student.ShiftId);

        this.divisionsFiltered = this.divisionService.divisions.filter(e => e.CurriculumId == this.data.student.CurriculumId && e.ShiftId == this.data.student.ShiftId)    
        console.log(this.data.student.DivisionId);
        console.log(this.divisionsFiltered);
    }

    setMarker($event: any) {
        // console.log('FuseAddStoreComponent > setMarker > $event', $event);
        this.markerLngX = $event.coords.lng;
        this.markerLatY = $event.coords.lat;
    }

    getNombreByFormControl(formControlName: string): string {
        return this.formControlTitles[formControlName] || 'Desconocido';
    }
    
    save() {
        Object.keys(this.studentFormGroup.controls).forEach(key => {
            const control = this.studentFormGroup.get(key);
            if (typeof control.value === 'string') {
            control.setValue(control.value.trim(), { emitEvent: false });
            }
        });
        console.log(this.studentFormGroup.controls);

        if (!this.studentFormGroup.valid) {
            let errors = []
            Object.keys(this.studentFormGroup.controls).forEach(key => {
                const controlErrors: ValidationErrors = this.studentFormGroup.get(key).errors;
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach(keyError => {
                        const fieldLabel = this.translate.instant(this.getNombreByFormControl(key));
                        this.translate.instant('VALIDATIONS.REQUIRED_OR_ERROR', { value: fieldLabel });
                        errors.push(this.translate.instant('VALIDATIONS.REQUIRED_OR_ERROR', { value: fieldLabel }))
                    });
                }
            });
            let errorHtml = '<ul  style="text-align: left;">';
            errors.forEach(error => {
                errorHtml += `<li> ${error}</li>`;  // Utiliza &#8226; para puntos (•), puedes usar * o cualquier otro símbolo
            });

            errorHtml += '</ul>';
            this.sweetAlertService.errorWait('Error', errorHtml, null);
            return;
        }

        if (this.data.mode === 'new') {
            console.log('nuevo');
            this.addStudent();
        } else {
            console.log('editar');
            this.editStudent();
        }
    }

    addStudent() {
        this.blockUI.start(this.translationService.savingChanges);
        const addStudentDto = new AddStudentDto();

        addStudentDto.FirstName = this.data.student.FirstName;
        addStudentDto.LastName = this.data.student.LastName;
        addStudentDto.DocumentNumber = this.data.student.DocumentNumber;
        addStudentDto.CUIL = this.data.student.CUIL;
        addStudentDto.Email = this.data.student.Email;
        addStudentDto.Birthdate = this.data.student.Birthdate;
        addStudentDto.DivisionId = this.data.student.DivisionId;
        addStudentDto.PersonGenderId = this.data.student.PersonGenderId;
        addStudentDto.PhoneNumber = this.data.student.PhoneNumber;
        addStudentDto.MobilePhoneNumber = this.data.student.MobilePhoneNumber;
        addStudentDto.AnotherContactPhone = this.data.student.AnotherContactPhone;
        addStudentDto.Address = this.data.student.Address;
        addStudentDto.Nationality = this.data.student.Nationality;
        addStudentDto.OtherPhoneBelongs = this.data.student.OtherPhoneBelongs;
        addStudentDto.Location = this.data.student.Location;
        addStudentDto.Tutor.Ocupation = this.data.student.Tutor.Ocupation;
        addStudentDto.SchoolOrigin = this.data.student.SchoolOrigin;
        addStudentDto.Observation = this.data.student.Observation;
        addStudentDto.HasBrothersOfSchoolAge = this.data.student.HasBrothersOfSchoolAge;
        addStudentDto.IdCardBack = this.data.student.IdCardBack;
        addStudentDto.IdCardFront = this.data.student.IdCardFront;
        addStudentDto.BelongsEthnicGroup = this.data.student.BelongsEthnicGroup;
        addStudentDto.EthnicName = this.data.student.EthnicName;
        addStudentDto.HasHealthProblems = this.data.student.HasHealthProblems;
        addStudentDto.DescriptionHealthProblems = this.data.student.DescriptionHealthProblems;
        addStudentDto.HasLegalProblems = this.data.student.HasLegalProblems;
        addStudentDto.DescriptionLegalProblems = this.data.student.DescriptionLegalProblems;


        addStudentDto.FileNumber = this.data.student.FileNumber;
        addStudentDto.Libro = this.data.student.Libro;
        addStudentDto.Folio = this.data.student.Folio;
        addStudentDto.HasSubjectsPending = this.data.student.HasSubjectsPending;
        addStudentDto.PendingSubjects = addStudentDto.HasSubjectsPending == true?this.data.student.PendingSubjects: "";
        addStudentDto.BelongsRuralCommunity = this.data.student.BelongsRuralCommunity;
        addStudentDto.RuralCommunity = this.data.student.RuralCommunity;
        addStudentDto.HasProgresarPlan = this.data.student.HasProgresarPlan;
        addStudentDto.HasGovernmentPC = this.data.student.HasGovernmentPC;
        addStudentDto.HasInternet = this.data.student.HasInternet;


        addStudentDto.Tutor.FirstName = this.data.student.Tutor.FirstName;
        addStudentDto.Tutor.LastName = this.data.student.Tutor.LastName;
        addStudentDto.Tutor.DocumentNumber = this.data.student.Tutor.DocumentNumber;
        addStudentDto.Tutor.CUIL = this.data.student.Tutor.CUIL;
        addStudentDto.Tutor.Email = this.data.student.Tutor.Email;
        addStudentDto.Tutor.Birthdate = this.data.student.Tutor.Birthdate;
        addStudentDto.Tutor.PersonGenderId = this.data.student.Tutor.PersonGenderId;
        addStudentDto.Tutor.RelationshipId = this.data.student.Tutor.RelationshipId;
        addStudentDto.Tutor.PhoneNumber = this.data.student.Tutor.PhoneNumber;
        addStudentDto.Tutor.MobilePhoneNumber = this.data.student.Tutor.MobilePhoneNumber;
        addStudentDto.Tutor.AnotherContactPhone = this.data.student.Tutor.AnotherContactPhone;
        addStudentDto.Tutor.Address = this.data.student.Tutor.Address;
        addStudentDto.Tutor.Nationality = this.data.student.Tutor.Nationality;
        addStudentDto.Tutor.HighestEducationLevel = this.data.student.Tutor.HighestEducationLevel;
        addStudentDto.Tutor.Location = this.data.student.Tutor.Location;
        addStudentDto.Tutor.IdCardBack = this.data.student.Tutor.IdCardBack;
        addStudentDto.Tutor.IdCardFront = this.data.student.Tutor.IdCardFront;
        addStudentDto.SchoolYearId = this.authenticationService.getAuthData().SchoolYear.Id;
        addStudentDto.Documentations = this.documentations.filter(d => d.Checked).map(d => d.Id);
        this.data.student.Documentations = this.documentations.filter(d => d.Checked).map(d => d.Id);
        addStudentDto.Payments = this.data.student.Payments;

        this.studentService.add(addStudentDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.data.student.Id = response.Id;
                this.studentService.students.push(this.data.student);
                this.studentService.studentObject[this.data.student.Id] = this.data.student;
                this.dialogRef.close(this.data.student);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.student, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    selectAllContent($event) {
        if ($event.target.value === 0) {
            $event.target.select();
        }
    }

    editStudent() {
        this.blockUI.start(this.translationService.savingChanges);

        const addStudentDto = new AddStudentDto();

        addStudentDto.Id = this.data.student.Id;
        addStudentDto.FirstName = this.data.student.FirstName;
        addStudentDto.LastName = this.data.student.LastName;
        addStudentDto.DocumentNumber = this.data.student.DocumentNumber;
        addStudentDto.CUIL = this.data.student.CUIL;
        addStudentDto.Email = this.data.student.Email;
        addStudentDto.Birthdate = this.data.student.Birthdate;
        addStudentDto.DivisionId = this.data.student.DivisionId;
        addStudentDto.PersonGenderId = this.data.student.PersonGenderId;
        addStudentDto.PhoneNumber = this.data.student.PhoneNumber;
        addStudentDto.MobilePhoneNumber = this.data.student.MobilePhoneNumber;
        addStudentDto.IdCardBack = this.data.student.IdCardBack;
        addStudentDto.IdCardFront = this.data.student.IdCardFront;
        addStudentDto.AnotherContactPhone = this.data.student.AnotherContactPhone;
        addStudentDto.Address = this.data.student.Address;
        addStudentDto.Location = this.data.student.Location;
        addStudentDto.OtherPhoneBelongs = this.data.student.OtherPhoneBelongs;
        addStudentDto.HasBrothersOfSchoolAge = this.data.student.HasBrothersOfSchoolAge;

        addStudentDto.BelongsEthnicGroup = this.data.student.BelongsEthnicGroup;
        addStudentDto.EthnicName = this.data.student.EthnicName;
        addStudentDto.HasHealthProblems = this.data.student.HasHealthProblems;
        addStudentDto.DescriptionHealthProblems = this.data.student.DescriptionHealthProblems;
        addStudentDto.HasLegalProblems = this.data.student.HasLegalProblems;
        addStudentDto.DescriptionLegalProblems = this.data.student.DescriptionLegalProblems;

        addStudentDto.FileNumber = this.data.student.FileNumber;
        addStudentDto.Libro = this.data.student.Libro;
        addStudentDto.Folio = this.data.student.Folio;
        addStudentDto.HasSubjectsPending = this.data.student.HasSubjectsPending;
        addStudentDto.PendingSubjects = addStudentDto.HasSubjectsPending == true ? this.data.student.PendingSubjects : "";
        addStudentDto.BelongsRuralCommunity = this.data.student.BelongsRuralCommunity;
        addStudentDto.RuralCommunity = this.data.student.RuralCommunity;
        addStudentDto.HasProgresarPlan = this.data.student.HasProgresarPlan;
        addStudentDto.HasGovernmentPC = this.data.student.HasGovernmentPC;
        addStudentDto.HasInternet = this.data.student.HasInternet;

        addStudentDto.Tutor.Id = this.data.student.Tutor.Id;
        addStudentDto.Tutor.FirstName = this.data.student.Tutor.FirstName;
        addStudentDto.Tutor.LastName = this.data.student.Tutor.LastName;
        addStudentDto.Tutor.DocumentNumber = this.data.student.Tutor.DocumentNumber;
        addStudentDto.Tutor.CUIL = this.data.student.Tutor.CUIL;
        addStudentDto.Tutor.Email = this.data.student.Tutor.Email;
        addStudentDto.Tutor.Birthdate = this.data.student.Tutor.Birthdate;
        addStudentDto.Tutor.PersonGenderId = this.data.student.Tutor.PersonGenderId;
        addStudentDto.Tutor.RelationshipId = this.data.student.Tutor.RelationshipId;
        addStudentDto.Tutor.HighestEducationLevel = this.data.student.Tutor.HighestEducationLevel;
        addStudentDto.Tutor.PhoneNumber = this.data.student.Tutor.PhoneNumber;
        addStudentDto.Tutor.MobilePhoneNumber = this.data.student.Tutor.MobilePhoneNumber;
        addStudentDto.Tutor.AnotherContactPhone = this.data.student.Tutor.AnotherContactPhone;
        addStudentDto.Tutor.Address = this.data.student.Tutor.Address;
        addStudentDto.Tutor.Nationality = this.data.student.Tutor.Nationality;
        addStudentDto.Tutor.Location = this.data.student.Tutor.Location;
        addStudentDto.Tutor.IdCardBack = this.data.student.Tutor.IdCardBack;
        addStudentDto.Tutor.IdCardFront = this.data.student.Tutor.IdCardFront;
        addStudentDto.Observation = this.data.student.Observation;
        addStudentDto.Nationality = this.data.student.Nationality;
        addStudentDto.Tutor.Ocupation = this.data.student.Tutor.Ocupation;
        addStudentDto.SchoolOrigin = this.data.student.SchoolOrigin;
        addStudentDto.SchoolYearId = this.authenticationService.getAuthData().SchoolYear.Id;
        addStudentDto.Documentations = this.documentations.filter(d => d.Checked).map(d => d.Id);
        this.data.student.Documentations = this.documentations.filter(d => d.Checked).map(d => d.Id);
        addStudentDto.Payments = this.data.student.Payments;
        console.log('************************>> studentDTO',addStudentDto);
        this.studentService.edit(addStudentDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                const index = this.studentService.students.findIndex(st => st.Id === this.data.student.Id);
                console.log('valor index', index);
                console.log(this.studentService.students[index]);
                this.studentService.students[index] = this.data.student;
                this.studentService.studentObject[this.data.student.Id] = this.data.student;
                this.dialogRef.close(this.data.student);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.student, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    getAge(birthdate: Date) {
        //   console.log("Edad>>>>>", birthdate);
        const momentNow = moment();
        const momentBirthdate = moment(birthdate);
        const diffDuration = moment.duration(momentNow.diff(momentBirthdate));
        let age = '';
        if (!!diffDuration.years() && diffDuration.years() > 0) {
            age += diffDuration.years().toString() + (diffDuration.years() === 1 ? ' año' : ' años');
        }
        if (!!diffDuration.months() && diffDuration.months() > 0) {
            // tslint:disable-next-line:max-line-length
            // age += age == '' ? diffDuration.months().toString() + (diffDuration.months() == 1 ? ' mes' : ' meses') : ', ' + (diffDuration.months().toString() + (diffDuration.months() == 1 ? ' mes' : ' meses'));
            if ((momentBirthdate.month() === momentNow.month()) && (momentNow.date() <= momentBirthdate.date())) {
                age = (diffDuration.years() + 1).toString() + ((diffDuration.years() + 1) === 1 ? ' año' : ' años');
            } else {
                // tslint:disable-next-line:max-line-length
                age += age === '' ? diffDuration.months().toString() + (diffDuration.months() === 1 ? ' mes' : ' meses') : ', ' + (diffDuration.months().toString() + (diffDuration.months() === 1 ? ' mes' : ' meses'));
            }
        }
        return age;
    }

    uploadPhoto(event: any, tipo: number) {
        console.log('FuseAddStudentComponent > uploadPhoto > event', event);
        const file = event.target.files[0];
        const maxFileSize = 1 * 1024 * 1024; // 1Mb
        console.log('FuseAddStudentComponent > uploadPhoto > maxFileSize', maxFileSize);
        console.log('FuseAddStudentComponent > uploadPhoto > file.zize', file.size);
        if (file.size > maxFileSize) {
            this.translationService.translate('ERRORS.MAXIMUM_SIZE_EXCEEDED', '1Mb', (res) => {
                this.sweetAlertService.error(this.translationService.success, res, null);
            });
            return;
        }
        this.blockUI.start();
        this.imageService.upload(file, 'this.data.student.id', 'profile').subscribe(response => {
            console.log('FuseAddStudentComponent > uploadPhoto > response', response, this.data.student, tipo);

            this.blockUI.stop();
            if (response.ResultCode === 1) {
                if (tipo === 1) {
                    this.data.student.IdCardBack = response.FileName;
                } else if (tipo === 2) {
                    this.data.student.IdCardFront = response.FileName;
                } else if (tipo === 3) {
                    this.data.student.Tutor.IdCardBack = response.FileName;
                } else if (tipo === 4) {
                    this.data.student.Tutor.IdCardFront = response.FileName;
                }
                this.data.student.UpdatedAt = new Date(Date.now());
                this.data.student.Tutor.UpdatedAt = new Date(Date.now());
                this.translationService.translate('LABELS.CORRECTLY_UPLOADED_FEMALE', this.translationService.photo, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    viewImage(src) {
        if (src !== undefined && src !== '') {
            const _album: Array<any> = [];
            const album = {
                src: this.baseUri + src
            };

            _album.push(album);
            console.log('_album', _album);
            this._lightbox.open(_album, 0, {centerVertically: true});
        }
    }

    getOrientation(src) {
        if (src !== undefined && src !== '') {
            const img = new Image();
            img.src = this.baseUri + src;
            const width = img.width;
            const height = img.height;
            // height = height + height // Double the height to get best
            // height = height + (height / 2) // Increase height by 50%
            if (width > height) {
                return 'landscape';
            } else {
                return 'portrait';
            }
        }
        return 'landscape';
    }

    addPayment() {
        const payment = new Payment();

        const config: MatDialogConfig = {
            // height: '75%',
            width: '400px',
            height: '350px',
            disableClose: true,
            data: {
                mode: 'new',
                payment: JSON.parse(JSON.stringify(payment))
            }
        };

        this.confirmDialogRef = this.dialog.open(PaymentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result) {
                const found = this.data.student.Payments.find(p => p.Id === result.Id);
                if (found) {
                    found.Id = result.Id;
                    found.Date = result.Date;
                    found.Amount = result.Amount;
                    found.PaymentConceptId = result.PaymentConceptId;
                    found.Observation = result.Observation;
                    found.ReceiptNumber = result.ReceiptNumber;
                } else {
                    const pay = new Payment();
                    pay.Id = result.Id;
                    pay.Date = result.Date;
                    pay.Amount = result.Amount;
                    pay.PaymentConceptId = result.PaymentConceptId;
                    pay.Observation = result.Observation;
                    pay.ReceiptNumber = result.ReceiptNumber;

                    this.data.student.Payments.push(pay);
                }
            }
        });
    }

    editPayment(payment) {
        const config: MatDialogConfig = {
            // height: '75%',
            width: '400px',
            height: '350px',
            disableClose: true,
            data: {
                mode: 'edit',
                payment: JSON.parse(JSON.stringify(payment))
            }
        };

        this.confirmDialogRef = this.dialog.open(PaymentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result) {
                const found = this.data.student.Payments.find(p => p.Id === result.Id);
                if (found) {
                    found.Id = result.Id;
                    found.Date = result.Date;
                    found.Amount = result.Amount;
                    found.PaymentConceptId = result.PaymentConceptId;
                    found.Observation = result.Observation;
                    found.ReceiptNumber = result.ReceiptNumber;
                } else {
                    const pay = new Payment();
                    pay.Id = result.Id;
                    pay.Date = result.Date;
                    pay.Amount = result.Amount;
                    pay.PaymentConceptId = result.PaymentConceptId;
                    pay.Observation = result.Observation;
                    pay.ReceiptNumber = result.ReceiptNumber;

                    this.data.student.Payments.push(pay);
                }
            }
        });
    }

    deletePayment(payment) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', '', (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                const found = this.data.student.Payments.find(p => p.Id === payment.Id);
                if (found) {
                    found.IsActive = false;
                }
            }, () => {
                console.log('FuseStudentComponent > delete > canceled');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/add-student/add-student.component.ts